export enum TraitType {
  LIFE = 'Life',
  WORK = 'Work',
}

export function setTraitType(type: TraitType) {
  if (type === TraitType.LIFE) {
    return TraitType.LIFE;
  } else if (type === TraitType.WORK) {
    return TraitType.WORK;
  }
  return null;
}
